import { useEffect } from "react";
import { AppTenantConfig } from "tenants/ThemeInjector";

export const BrandingHeader = () => {
    useEffect(() => {
        document.title = AppTenantConfig.brand.name
        const faviconUrl = AppTenantConfig.assets.favicon;

        // Find existing <link rel="icon">
        let link = document.querySelector("link[rel*='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }

        // Set the dynamic favicon
        link.href = faviconUrl;
    }, [AppTenantConfig.assets.favicon]);

    return <></>;
};